import styled, { css } from 'styled-components';
import Form from '../../molecules/Form';

export const StyledTabSetComponents = styled(Form)`
  width: 100%;
  ${({ $childBorder }) =>
    $childBorder &&
    css`
      margin-top: 20px;
      border: 1px solid #f1f1f1;
      border-radius: 25px;
      padding: 20px 30px;
    `}
  .form-control-custom {
    width: 100%;
    label {
      font-weight: 400;
    }
    input {
      height: 45px;
      font-size: 12px;
      font-weight: 400;
      background: var(--white);

      &::placeholder {
        font-weight: 300;
      }
    }
    span {
      color: #313131;
      font-size: 12px;
      font-weight: 300;
      line-height: 14px;
    }
  }
  .tab-body-header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0 30px;
    border-bottom: 1px solid rgba(241, 241, 241, 1);
    margin-bottom: 30px;
    @media (max-width: 576px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;
    }
    .title {
      font-size: 18px;
      font-weight: 400;
      line-height: 20px;
      text-align: left;
    }
  }
  .switch-wrap {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .tab-body-body {
    max-height: 530px;
    overflow-y: auto;
    padding-right: 10px;
    margin-bottom: 10px;
    display: flex;
    width: 100%;
    gap: 20px;
    @media (max-width: 992px) {
      display: block;
    }
    .title {
      display: block;
      margin-bottom: 16px;
      font-size: 14px;
      font-weight: 400;
      line-height: 17px;
    }
    .terminal-switch {
      width: 100%;

      .terminal-text {
        padding-bottom: 20px;
        border-bottom: 1px solid rgba(241, 241, 241, 1);
        margin-bottom: 20px;
        .text {
          font-size: 14px;
          font-weight: 300;
          line-height: 17px;
          text-align: left;
        }
      }
      .terminal-switch-wrap {
        display: flex;
        @media (max-width: 992px) {
          display: block;
        }
      }
    }
    .maintenance-btn {
      display: flex;
      width: 100%;
      gap: 20px;
      margin-bottom: 30px;
    }
  }

  .submission-wrapper {
    display: flex;
    gap: 15px;
    max-width: 140px;
    width: 100%;
    margin-left: auto;
  }
  .noflex {
    display: block;
  }
  .mb {
    margin-bottom: 20px;
  }
  .noMb {
    margin-bottom: 0px !important;
  }
  .col-wrapper {
    border-top: 1px solid #f1f1f1;
    padding: 30px 0 16px;
    margin-bottom: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;
    position: relative;
    @media (max-width: 992px) {
      grid-template-columns: 1fr;
      gap: 10px;
    }
    &:before {
      content: '';
      position: absolute;
      top: 20px;
      bottom: 0;
      left: 50%;
      transform: translateX(50%);
      width: 1px;
      background: #f1f1f1;
      @media (max-width: 992px) {
        display: none;
      }
    }
    .col {
      /* border-right: 1px solid #f1f1f1; */
      /* max-width: 330px; */
    }
  }
  .combine-fields {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 20px;
    @media (max-width: 992px) {
      display: block;
    }
  }
  .printer-switch {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
    @media (max-width: 992px) {
      flex-wrap: wrap;
    }
  }
  .wrap {
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }
  .footer-col-wrap {
    padding-top: 20px;
    border-top: 1px solid #f1f1f1;
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 16px;
    column-gap: 20px;
    margin-bottom: 30px;
    @media (max-width: 992px) {
      grid-template-columns: 1fr;
    }
    .footer-col {
      border: 1px solid #f1f1f1;
      padding: 14px;
      border-radius: 20px;
      .col-title {
        display: block;
        margin-bottom: 18px;
        font-size: 13px;
        font-weight: 400;
        line-height: 16px;
        color: #313131;
        text-align: left;
      }
    }
    .labelButton {
      height: 330px;
    }
  }
  .header-col-wrap {
    .footer-col {
      margin-bottom: 16px;
    }
  }
  .upload-img-wrap {
    > div:first-of-type {
      position: relative;
      &::before {
        position: absolute;
        content: '';
        background: rgba(0, 0, 0, 0.4);
        width: 100%;
        height: 100%;
        border-radius: 20px;
        z-index: 2;
        opacity: 0;
        visibility: hidden;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
      }
      &:hover {
        &::before {
          opacity: 1;
          visibility: visible;
        }
        .upload-text {
          position: relative;
          z-index: 3;
          color: var(--white);
          transition: all 0.2s ease-in-out;
          img {
            filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(86deg) brightness(200%) contrast(120%);
            transition: all 0.2s ease-in-out;
          }
        }
      }
    }
  }
`;
